const publicPath = process.env.BASE_URL

export const defaultLogo = `${publicPath}logos/corporate.png`
export const defaultNewsAvatar = `${publicPath}logos/logo-leti-round.png`
export const imagePreview = `${publicPath}image-preview.jpeg`
